<template lang="pug">
  v-container
    v-fade-transition(
      mode="out-in"
      :key="isRedirecting")
      illustration-state(
        :illustration="illustration"
        :title="title"
        :height="300"
        :body="body")
        template(
          v-if="!isRedirecting"
          #actions)
          v-progress-circular(:value="progress")
</template>

<script>
import { onMounted, reactive, toRefs, computed, watch } from '@vue/composition-api'
import { page, injectRouteState } from '@iez/core'
import truncateDecimalNumber from '@iez/lib/truncate-decimal-number/'
import router from '@iez/core/router/'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import waitFor from '@iez/lib/wait-for/'
import illustrationImage from '@iez/illustrations/UploadImage'
import illustrationVideo from '@iez/illustrations/VideoUpload'
import illustrationDone from '@iez/illustrations/Festivities'
import IllustrationState from '@iez/components/illustration-state/'
import initNativeCallback from '@iez/lib/init-native-callback/'
import addPropertyIfExists from '@iez/lib/add-property-if-exists/'

const route = {
  name: `AddUploading`,
  path: `/add-uploading`
}

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    const routeStateAddSetup = injectRouteState({
      name: `AddSetup`
    })

    const routeStateAddPayment = injectRouteState({
      name: `AddPayment`
    })

    const isAllowed = routeStateAddSetup.name
      && (
        routeStateAddSetup.isAdmin ||
        routeStateAddPayment.paymentId
      )
    if (!isAllowed) {
      router.replace(`/`)
    }

    page.topBar.set({
      title: computed(() => state.isRedirecting ? `Redirection` : `Paiement effectué`)
    })

    const state = reactive({
      illustration: computed(
        () => state.isRedirecting
          ? illustrationDone
            : {
              video: illustrationVideo,
              image: illustrationImage
            }[routeStateAddSetup.type]
      ),
      progress: 0,
      body: computed(
        () =>
          state.isRedirecting
            ? `Vous allez être redirigé.`
            : `${truncateDecimalNumber({ value: state.progress, decimalCount: 2 })}%`
      ),
      isRedirecting: false,
      title: computed(
        () =>
          state.isRedirecting
            ? routeStateAddSetup.type === `ko-don`
              ? `Bravo ! Votre ko-Don est publié`
              : `Bravo ! Votre annonce est publiée`
            : routeStateAddSetup.type === `video`
              ? routeStateAddSetup.file.compressedFilePath
                ? `Mise en ligne de l'annonce vidéo...`
                : `Optimisation de la vidéo en cours...`
              : routeStateAddSetup.type === `ko-don`
                ? `Création du ko-Don...`
                : `Mise en ligne de l'annonce image...`
      )
    })

    /* const { callback: nativeCompressVideo } = initNativeCallback({
      name: `compressVideo`,
      onResult: data => {
        state.progress = data.progress
      }
    }) */

    const { callback: nativeUpload } = initNativeCallback({
      name: `upload`,
      onResult: data => {
        state.progress = data.progress
      }
    })

    const configuration = data.get({
      root: `configurations`,
      fields: [
        `id`,
        `percentage`,
        `percentageKodon`
      ],
      request: {
        order_by: {
          createdAt: `desc`
        }
      },
      one: true
    })

    const getPercentage = async () => {
      await waitFor({
        dependencies: () => routeStateAddSetup.type === `ko-don`
          ? configuration.value?.percentageKodon
          : configuration.value?.percentage
      })

      return configuration.value.percentage
    }

    const me = data.me({
      fields: [
        `id`,
        `isAdmin`
      ]
    })

    onMounted(async () => {
      const type = routeStateAddSetup.type

      const getFileId =  async () => {
        const file = data.upload({
          file: routeStateAddSetup.file?.path ?? routeStateAddSetup.file,
          type,
          ...addPropertyIfExists({
            name: `nativeCallback`,
            value:  window.ReactNativeWebView ? nativeUpload : null
          })
        })

        watch(
          () => file.progress,
          progress => {
            state.progress = progress
          }
        )

        await waitFor({
          dependencies: () => file.progress === 100
        })

        return file.id
      }

      await data.set({
        root: `ads`,
        fields: [`id`],
        items: [{
          ...type !== `ko-don`
            ? {
              [`${type}Id`]: await getFileId(),
            } : {
              videoId: `c307809c-37fe-4bff-9372-716ccc33342f`
            },
          authorId: user.id,
          name: routeStateAddSetup.name,
          paymentId: routeStateAddPayment.paymentId,
          pricePerView: Math.floor(routeStateAddSetup.pricePerView * (me.value?.isAdmin ? 100 : await getPercentage())),
          viewsCountTotal: routeStateAddSetup.viewsCountTotal,
          viewsCountRemaining: routeStateAddSetup.viewsCountTotal,
          endingMessage: routeStateAddSetup.endingMessage,
          endingUrl: routeStateAddSetup.endingUrl
        }]
      })

      /**
       * Redirection
       */
      state.progress = 100
      setTimeout(() => {
        state.isRedirecting = true
        setTimeout(() => {
          router.push({
            name: `Home`
          })
        }, 4000)
      }, 2000)
    })

    return {
      routeStateAddSetup,
      routeStateAddPayment,
      ...toRefs(state)
    }
  }
}
</script>
